(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[369],{

/***/ 7189:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rides-and-activities/[slug]",
      function () {
        return __webpack_require__(3838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Safety_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6918);
/* harmony import */ var _Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);



const Safety = (param)=>{
    let { highlights  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "".concat((_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().top_sec), " common_padding"),
        id: "helicopter_sec",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: highlights.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().highlight_child), " col-md-4 common_title animate_box"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: item.icon,
                                    width: 44,
                                    height: 44,
                                    alt: item.title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: item.description
                            })
                        ]
                    }, index))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Safety);


/***/ }),

/***/ 1305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Safety_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6918);
/* harmony import */ var _Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);



const SafetyList = ()=>{
    const safetyLists = [
        {
            title: "Rigorous Ride Inspections",
            icon: "/icons/groups/inspections.png"
        },
        {
            title: "Staff Training and Safety Protoclos",
            icon: "/icons/groups/staff.png"
        },
        {
            title: "Clear and Visible Safety Signage",
            icon: "/icons/groups/clear.png"
        },
        {
            title: "Emergency Response Preparedness",
            icon: "/icons/groups/emergency.png"
        },
        {
            title: "Safety Briefings for Groups",
            icon: "/icons/groups/safety.png"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "".concat((_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().speciality_sec), " common_padding"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().speciality_child), " row align-items-center justify-content-center"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat((_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().safety_first_sec), " col-md-8 common_title text-center mobile_text_center"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: "Safety First"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().safety_sec_content),
                            children: safetyLists.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Safety_module_scss__WEBPACK_IMPORTED_MODULE_2___default().safety_sec_content_card),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: item.icon,
                                            height: 50,
                                            width: 50,
                                            alt: item.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: item.title
                                        })
                                    ]
                                }, item.title))
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafetyList);


/***/ }),

/***/ 5871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4199);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9521);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9664);
/* harmony import */ var gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(3454);






if (process.client) {
    gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__.ScrollToPlugin);
}
function Topbanner(props) {
    const handleClick = (e)=>{
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.registerPlugin(gsap_dist_ScrollToPlugin__WEBPACK_IMPORTED_MODULE_4__.ScrollToPlugin);
        e.stopPropagation();
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: "".concat(props.target),
                offsetY: 70
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_5___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container common_title",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: props.title
                        }),
                        props.button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            className: "common_btn",
                            children: props.button
                        }) : ""
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Topbanner);


/***/ }),

/***/ 6436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const Gallerymodal = (param)=>{
    let { clickedImage , handleRotationRight , setClickedImage  } = param;
    const handleClick = (e)=>{
        if (e.target.classList.contains("dismiss")) {
            setClickedImage(null);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "modal_overlay dismiss",
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: "modal_image",
                    src: clickedImage,
                    alt: "biger pcture"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "dismiss close_icon",
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/close-white.svg",
                        className: "dismiss",
                        onClick: handleClick,
                        width: 20,
                        height: 20,
                        alt: "Close arrow"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: handleRotationRight,
                    className: "overlay-arrows_left",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/left-white.svg",
                        width: 30,
                        height: 30,
                        alt: "Left Icon"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: handleRotationRight,
                    className: "overlay-arrows_right",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/icons/right-white.svg",
                        width: 30,
                        height: 30,
                        alt: "Right Icon"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Gallerymodal);


/***/ }),

/***/ 3838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Room; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/components/Reusable/Banner/Topbanner.js
var Topbanner = __webpack_require__(5871);
// EXTERNAL MODULE: ./src/styles/Pages/RidesAndActivities.module.scss
var RidesAndActivities_module = __webpack_require__(143);
var RidesAndActivities_module_default = /*#__PURE__*/__webpack_require__.n(RidesAndActivities_module);
// EXTERNAL MODULE: ./src/components/Reusable/Activitygallery/Activitygallery.module.scss
var Activitygallery_module = __webpack_require__(5626);
var Activitygallery_module_default = /*#__PURE__*/__webpack_require__.n(Activitygallery_module);
// EXTERNAL MODULE: ./src/components/Reusable/Gallerymodal/Gallerymodal.js
var Gallerymodal = __webpack_require__(6436);
// EXTERNAL MODULE: ./src/components/Reusable/Buttons/Buttons.js
var Buttons = __webpack_require__(28);
;// CONCATENATED MODULE: ./src/components/Reusable/Activitygallery/Activitygallery.js








function Activitygallery(param) {
    let { Images , title  } = param;
    const [clickedImage, setClickedImage] = (0,react.useState)(null);
    const [currentIndex, setCurrentIndex] = (0,react.useState)(null);
    const [galleryImages, setGalleryImagees] = (0,react.useState)(Images);
    const settings = {
        infinite: true,
        arrows: true,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const handleClick = (item, index)=>{
        setCurrentIndex(index);
        setClickedImage(item.image);
    };
    const handleRotationRight = ()=>{
        const totalLength = galleryImages.length;
        if (currentIndex + 1 >= totalLength) {
            setCurrentIndex(0);
            const newUrl = galleryImages[0].image;
            setClickedImage(newUrl);
            return;
        }
        const newIndex = currentIndex + 1;
        const newUrl1 = galleryImages.filter((item)=>{
            return galleryImages.indexOf(item) === newIndex;
        });
        const newItem = newUrl1[0].image;
        setClickedImage(newItem);
        setCurrentIndex(newIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "".concat((Activitygallery_module_default()).gallery_sec),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "common_title text-center pb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            children: [
                                title ? title : "Our",
                                " Gallery"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Activitygallery_module_default()).gallery_main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...settings,
                                className: "activity_gallery_slider",
                                children: galleryImages.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Activitygallery_module_default()).gallery_child,
                                        onClick: ()=>handleClick(item, index),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: item.image,
                                                onClick: ()=>handleClick(item, index),
                                                alt: "Gallery Image ".concat(index + 1)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Activitygallery_module_default()).gallery_inner
                                            })
                                        ]
                                    }, index))
                            }),
                            clickedImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallerymodal/* default */.Z, {
                                clickedImage: clickedImage,
                                handleRotationRight: handleRotationRight,
                                setClickedImage: setClickedImage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12 d-flex justify-content-center mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* AncorSecoundaryButton */.UY, {
                            redirectPage: "/rides-and-activities",
                            className: "margin_0_auto",
                            buttonText: "Explore All"
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var Activitygallery_Activitygallery = (Activitygallery);

// EXTERNAL MODULE: ./src/components/Heighlights/Heighlights.js
var Heighlights = __webpack_require__(471);
// EXTERNAL MODULE: ./src/components/Heighlights/SafetyList.js
var SafetyList = __webpack_require__(1305);
;// CONCATENATED MODULE: ./src/pages/rides-and-activities/[slug].js














var $ = __webpack_require__(9755);
if (true) {
    window.$ = window.jQuery = __webpack_require__(9755);
}
var __N_SSG = true;
function Room(param) {
    let { attraction , allAttractions  } = param;
    const [filteredAttraction, setFilteredAttraction] = (0,react.useState)(allAttractions);
    let filteredArray = filteredAttraction.filter((item)=>item.slug !== attraction.slug);
    const activityVideoId = attraction.activityVideo;
    // console.log(activityVideoId);
    const similarAttractions = filteredArray;
    const settings = {
        infinite: true,
        arrows: true,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const Images = attraction.galleryImages;
    // useEffect(() => {
    //     function loadVideo() {
    //         window.YT.ready(function () {
    //             const youtubeplayer = new window.YT.Player("singleActivityPlayer", {
    //                 height: "100%",
    //                 width: "100%",
    //                 videoId: activityVideoId,
    //                 playerVars: { 'playsinline': 1, 'modestbranding': 1, 'autohide': 1, 'showinfo': 0, 'rel': 0, 'controls': 0 },
    //                 events: {
    //                     onReady: onPlayerReady,
    //                     onStateChange: onPlayerStateChange,
    //                 }
    //             });
    //         });
    //         function onPlayerReady(event) {
    //             event.target.playVideo();
    //             // Get video title and set as title attribute
    //             var playerTitle = event.target.getVideoData().title;
    //             var playerElement = document.getElementById("singleActivityPlayer");
    //             playerElement.setAttribute("title", playerTitle);
    //         }
    //         function onPlayerStateChange(event) {
    //             var videoStatuses = Object.entries(window.YT.PlayerState);
    //         }
    //     }
    //     $(document).ready(function () {
    //         $.getScript("https://www.youtube.com/iframe_api", function () {
    //             loadVideo();
    //         });
    //     });
    // }, []);
    // const roomamenities = room.amenities
    // const galleryImg = room.gallery
    const highlights = [
        {
            icon: "/icons/thrill.svg",
            title: "Thrill for Everyone",
            description: " Every one of our pilots have a valid license and possesses the knowledge, experience, and expertise required of someone with the skill level of a pilot. This includes having a complete comprehension of the factors that a pilot needs to be aware of in order to ensure the safety of the passengers."
        },
        {
            icon: "/icons/safety-first.svg",
            title: "Safety First, Thrills Second",
            description: "We have more than five years of expertise in the field of helicopter safari, during which time we have provided tourists with genuine and exciting adventures. Because of this, our pilots are highly trained professionals who are equipped with all of the necessary skills and information to ensure the safety of the passengers."
        },
        {
            icon: "/icons/family-star.svg",
            title: "Unforgettable Adventure",
            description: "More than five hundred individuals have been able to experience the thrill of one of our helicopter safaris up to this point. This helicopter safari was built from the ground up to provide the maximum amount of personal attention to each guest and to fulfill their every desire for an exciting trip."
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: attraction.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: attraction.metaDesc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: attraction.metaKeywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.adventureresortkufri.com/rides-and-activities/".concat(attraction.slug)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbanner/* default */.Z, {
                title: attraction.title,
                bgImage: attraction.bannerImage,
                target: "#firstsec"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((RidesAndActivities_module_default()).single_attraction, " common_padding"),
                id: "firstsec",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row justify-content-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((RidesAndActivities_module_default()).single_attraction_content, " col-md-8 common_title ride_activity_title"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: attraction.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: attraction.longDesc
                                    })
                                ]
                            }),
                            (attraction === null || attraction === void 0 ? void 0 : attraction.activityVideo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((RidesAndActivities_module_default()).single_attraction_video, " col-md-8"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                                    width: "100%",
                                    height: "100%",
                                    controls: true,
                                    loop: true,
                                    autoPlay: true,
                                    muted: true,
                                    title: "Go-Karting by Adventure Resort",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                            src: "/video/go-karting.mp4",
                                            type: "video/mp4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                            itemProp: "uploadDate",
                                            content: "2023-12-10"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                            itemProp: "thumbnailUrl",
                                            content: "https://www.adventureresortkufri.com/images/activitiesimages/single-attrac-banner.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("track", {
                                            src: "/path/to/captions.vtt",
                                            kind: "subtitles",
                                            srcLang: "en",
                                            label: "English"
                                        })
                                    ]
                                })
                            }) : "",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((RidesAndActivities_module_default()).buy_ticket_btn, " col-md-12 d-flex justify-content-center mt-4"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* AncorSecoundaryButton */.UY, {
                                    redirectPage: "/tickets",
                                    className: "margin_0_auto",
                                    buttonText: "BUY TICKETS"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Activitygallery_Activitygallery, {
                Images: Images,
                title: attraction.title
            }, attraction.slug)
        ]
    });
}


/***/ }),

/***/ 6918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_sec":"Safety_top_sec__69Zy2","highlight_child":"Safety_highlight_child__cb_lM","speciality_sec":"Safety_speciality_sec__8SyFL","safety_first_sec":"Safety_safety_first_sec__ji_sZ","safety_sec_content":"Safety_safety_sec_content__A64AN","safety_sec_content_card":"Safety_safety_sec_content_card__EHDk9"};

/***/ }),

/***/ 5626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery_sec":"Activitygallery_gallery_sec__kT0F8","gallery_main":"Activitygallery_gallery_main__5W0te","gallery_child":"Activitygallery_gallery_child__JH5rB"};

/***/ }),

/***/ 4199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__JLDvP","banner_text":"Topbanner_banner_text__znygP","banner_btn":"Topbanner_banner_btn___Zjwb","down":"Topbanner_down__3Pfwj","home_banner":"Topbanner_home_banner__p1RdH","banner_text_con":"Topbanner_banner_text_con__K9pZF","without_image_banner":"Topbanner_without_image_banner__U6U0K"};

/***/ }),

/***/ 143:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"all_attractions":"RidesAndActivities_all_attractions__WRaNQ","attraction_child":"RidesAndActivities_attraction_child__qphdM","blog_child":"RidesAndActivities_blog_child__0GIPn","all_blogs":"RidesAndActivities_all_blogs__4nNCc","common_btn_parent":"RidesAndActivities_common_btn_parent__hSlC_","image_wrapper":"RidesAndActivities_image_wrapper__ULTWG","single_attraction":"RidesAndActivities_single_attraction__30Iq1","single_attraction_content":"RidesAndActivities_single_attraction_content__xMQuR","single_attraction_video":"RidesAndActivities_single_attraction_video__tiii3","buy_ticket_btn":"RidesAndActivities_buy_ticket_btn__cs0CL","activity_video":"RidesAndActivities_activity_video__CSW7B","all_stores":"RidesAndActivities_all_stores__12ozs","store_child":"RidesAndActivities_store_child__EGNF2","popup_bg":"RidesAndActivities_popup_bg__nNhYo","popup_align":"RidesAndActivities_popup_align__1aHvR","popup_content":"RidesAndActivities_popup_content__3ReKa","top_sec":"RidesAndActivities_top_sec__QoU0s","bottom_sec":"RidesAndActivities_bottom_sec___HuMk","similar_attraction":"RidesAndActivities_similar_attraction__OdCYE","activities_slider":"RidesAndActivities_activities_slider__KwOjD","activity_child":"RidesAndActivities_activity_child__wr3N7","restaurant_sec":"RidesAndActivities_restaurant_sec__esUVM","restasurant_main":"RidesAndActivities_restasurant_main__eIFCw","restaurnat_left":"RidesAndActivities_restaurnat_left__1LjsY","restaurnat_right":"RidesAndActivities_restaurnat_right__wHprm","highlights":"RidesAndActivities_highlights_____zn","activity_type_container":"RidesAndActivities_activity_type_container__1_zYZ","activity_type_parent":"RidesAndActivities_activity_type_parent___Vx7Z","activity_type_img":"RidesAndActivities_activity_type_img__TBYd_","skeleton":"RidesAndActivities_skeleton___7YtD","shimmer":"RidesAndActivities_shimmer__Rfy8Q","skeleton_image_wrapper":"RidesAndActivities_skeleton_image_wrapper__R5Rmk","skeleton_heading":"RidesAndActivities_skeleton_heading__j1382","skeleton_title":"RidesAndActivities_skeleton_title__Eilak","skeleton_btn":"RidesAndActivities_skeleton_btn__fBIoj","skelton_btn_parent":"RidesAndActivities_skelton_btn_parent__oKj8t"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,774,888,179], function() { return __webpack_exec__(7189); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);